import{connect}from'react-redux';import{appError as _appError}from"../../action-creators/error";/**
 * Connects the dispatch function to a callable function in the props.
 * @param {Function} dispatch The redux dispatch function.
 * @return {Object} The extended component props.
 */var mapDispatchToProps=function mapDispatchToProps(dispatch){return{appError:function appError(error){return dispatch(_appError(error));}};};export default connect(null,mapDispatchToProps);